import assistantIcon1 from 'assets/images/assistant-icon-1.svg';
import assistantIcon2 from 'assets/images/assistant-icon-2.svg';
import assistantIcon3 from 'assets/images/assistant-icon-3.svg';
import assistantIcon4 from 'assets/images/assistant-icon-4.svg';
import assistantIcon5 from 'assets/images/assistant-icon-5.svg';
import assistantIcon6 from 'assets/images/assistant-icon-6.svg';
import assistantIcon7 from 'assets/images/assistant-icon-7.svg';
import assistantIcon8 from 'assets/images/assistant-icon-8.svg';
import assistantIcon9 from 'assets/images/assistant-icon-9.svg';

export const ASSISTANT_ICONS = [
    { id: 'assistant-icon-1', src: assistantIcon1 },
    { id: 'assistant-icon-2', src: assistantIcon2 },
    { id: 'assistant-icon-3', src: assistantIcon3 },
    { id: 'assistant-icon-4', src: assistantIcon4 },
    { id: 'assistant-icon-5', src: assistantIcon5 },
    { id: 'assistant-icon-6', src: assistantIcon6 },
    { id: 'assistant-icon-7', src: assistantIcon7 },
    { id: 'assistant-icon-8', src: assistantIcon8 },
    { id: 'assistant-icon-9', src: assistantIcon9 },
];
